module.exports = __webpack_public_path__ + "static/media/unacceptable.7390634b.svg";